module.exports = __webpack_public_path__ + "static/media/3.c76f7c59.jpg";